import logo from '../../_assets/images/logo_kokoka.svg';

export default function KokokaLogo({ className }: { className: string }) {
  return (
    <>
      <img src={logo} alt="logo" className={className} />
    </>
  );
}
